// @flow
import { PRODUCT_ACTIVITIES } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_PRODUCT_ACTIVITIES } from 'Utils/request/requestDictionary';
import { productActivitiesQuery } from 'Client/cms/toolkit/product-utils/productFeatures.queries';

export const productActivitiesResolver = {
  name: PRODUCT_ACTIVITIES,
  resolve(
    appContext: AppContext,
    props: ProductActivitiesLineCMSProps,
    pageContext: PageContext,
    { urlParams }: RouterLocation<ProductUrlParams>,
  ): Promise<ProductActivitiesLineProps> {
    const {
      resortId: productId,
      otherSports: { label: defaultLabel },
    } = props;

    const query = productActivitiesQuery({ productId, defaultLabel, urlParams });
    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_PRODUCT_ACTIVITIES,
      strictErrors: false,
    });
  },
};
